import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom'
import { initialize,saveSubscription } from '../actions/subscriptionActions';

import Error from './Error';
import Loading from './Loading';

class Unsubscribe extends React.Component {

  componentDidMount() {
    var recipientUuid = this.props.match.params.recipientUuid;
    this.props.initialize(recipientUuid);
  }
  
  render() {
    var { error, recipient,isOptOut,isSaving,isUpdated,updateSuccess } = this.props;
    if (error) {
      return (
        <Error message={error.message}></Error>
      );
    } else if (!recipient || isSaving) {
      return (
        <Loading></Loading>
      );
    } else {
      if(!isOptOut) {
        this.props.saveSubscription(recipient,1);
        return (
          <Loading></Loading>
        );
      } else if (isUpdated && !updateSuccess) {
        return <Error />
      } else {
        var redirectUrl = '/email/' + this.props.match.params.language + '/' + this.props.match.params.recipientUuid;
        return <Redirect to={redirectUrl} />
      }

    }
  }
}


const mapStateToProps = state => ({
  recipient: state.recipient,
  error: state.error,
  isOptOut: state.status.saved,
  isSaving: state.status.isSaving,
  isUpdated: state.status.isUpdated,
  updateSuccess: state.status.updateSuccess
});


export default connect(mapStateToProps,{ initialize,saveSubscription })(Unsubscribe);